import { render } from "./TiptapEditor.vue?vue&type=template&id=112a696b"
import script from "./TiptapEditor.vue?vue&type=script&lang=js"
export * from "./TiptapEditor.vue?vue&type=script&lang=js"

import "./TiptapEditor.vue?vue&type=style&index=0&id=112a696b&lang=css"

import exportComponent from "/Users/ricpp/Development/boldbrush/blog_post_editor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__